import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isContactsPhone(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CONTACTS_PHONE && typeof label === 'string' && typeof value === 'string';
}
function _formatContactsPhone(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatContactsPhone(submission) {
  if (isContactsPhone(submission)) {
    return _formatContactsPhone(submission);
  }
  return undefined;
}
//# sourceMappingURL=contacts-phone-preview.js.map